import { useState, useCallback } from 'react'
import { adminApi } from '../api/adminApi'
import type { AdminMetrics } from '../types'
import { toast } from '../store/adminStore'

export function useMetrics() {
  const [metrics, setMetrics] = useState<AdminMetrics | null>(null)
  const [loading, setLoading] = useState(false)

  const fetch = useCallback(async () => {
    setLoading(true)
    try {
      const data = await adminApi.getMetrics()
      setMetrics(data)
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Failed to load metrics')
    } finally {
      setLoading(false)
    }
  }, [])

  return { metrics, loading, fetch }
}
